import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./style.scss";
import {
  //   FaThLarge,
  //   FaUsers,
  //   FaUserPlus,
  //   FaKey,
  FaArrowCircleLeft,
  FaArrowCircleRight,
} from "react-icons/fa";
import DASHBOARD_ICON from "../../assets/icons/dashboard.png";
import CUSTOMER_ICON from "../../assets/icons/customer.png";
import TICK_ICON from "../../assets/icons/tick.png";
import MESSAGE_ICON from "../../assets/icons/message.png";
import UTTERANCE_ICON from "../../assets/icons/utterance.png";
import ACTIVATION_ICON from "../../assets/icons/activation.png";
import { changePage } from "../../services/page/actions";

const Sidebar = ({ changePage, page, app }) => {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <div className={"sidebar_container" + (collapsed ? " collapsed" : "")}>
      <div className="links">
        <Link to="#" onClick={() => changePage(0)}>
          <img src={DASHBOARD_ICON} alt="dashboard" /> <span>Summary</span>
        </Link>
        <Link to="#" onClick={() => changePage(1)}>
          <img src={CUSTOMER_ICON} alt="dashboard" /> <span>Customer</span>
        </Link>
        <Link to="#" onClick={() => changePage(2)}>
          <img src={TICK_ICON} alt="dashboard" /> <span>Intent</span>
        </Link>
        {app.platform === "Alexa" ? (
          <Link to="#" onClick={() => changePage(4)}>
            <img src={ACTIVATION_ICON} alt="dashboard" />
            <span>Skill Activations</span>
          </Link>
        ) : (
          <Link to="#" onClick={() => changePage(3)}>
            <img src={UTTERANCE_ICON} alt="dashboard" /> <span>Utterance</span>
          </Link>
        )}
        <Link to="#" onClick={() => changePage(5)}>
          <img src={TICK_ICON} alt="dashboard" />{" "}
          <span>Conversation Paths</span>
        </Link>
        <Link to="#" onClick={() => changePage(6)}>
          <img src={MESSAGE_ICON} alt="dashboard" /> <span>Message</span>
        </Link>
      </div>
      <button onClick={() => setCollapsed(!collapsed)} className="toggle">
        {collapsed ? <FaArrowCircleRight /> : <FaArrowCircleLeft />}
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  app: state.filtersState.app,
});
export default connect(mapStateToProps, { changePage })(Sidebar);
